module.exports = __webpack_public_path__ + "static/media/dvd-sim.5ca7f696.png";